export const REACT_APP_BASE_URL= "http://localhost:5000/"
export const STAGING_IP="13.233.221.13"